<template>
  <v-list
    v-model:opened="open"
    nav
    density="compact"
    @update:opened="(newOpened) => (open = newOpened.slice(-2))"
  >
    <v-list-item prepend-icon="mdi-home" title="Accueil" to="/" ></v-list-item>

    <v-list-group value="GEC">
      <template v-slot:activator="{ props }">
        <v-list-item
          v-if="this.hasPermission('menu_gec')"
          v-bind="props"
          prepend-icon="mdi-folder-account"
          title="GEC"
        >
        </v-list-item>
      </template>

       <v-list-item
        v-if="this.hasPermission('view_gec_mail')"
        prepend-icon="mdi-chevron-right"
        title="Nouveau courrier"
        to="/mails/create"
      ></v-list-item>

      <v-list-item
        v-if="this.hasPermission('view_gec_mail')"
        prepend-icon="mdi-chevron-right"
        title="Mes courriers"
        to="/mails"
      ></v-list-item>

      <v-list-item
        v-for="([title, icon, path], i) in gec"
        :key="i"
        :value="title"
        :title="title"
        :prepend-icon="icon"
        :to="path"
      ></v-list-item>
    </v-list-group>

    <v-list-group value="GED">
      <template v-slot:activator="{ props }">
        <v-list-item
         v-if="this.hasPermission('menu_ged')"
          v-bind="props"
          prepend-icon="mdi-folder-account"
          title="GED"
        >
        </v-list-item>
      </template>


      <v-list-item
        v-if="this.hasPermission('view_ged_document')"
        prepend-icon="mdi-chevron-right"
        title="Indexation"
        to="/indexations"
      ></v-list-item>

      <v-list-item
        v-if="this.hasPermission('view_ged_request')"
        prepend-icon="mdi-chevron-right"
        title="Consultation"
        to="/consultations"
      ></v-list-item>

       <v-list-item
        v-for="([title, icon, path], i) in ged"
        :key="i"
        :value="title"
        :title="title"
        :prepend-icon="icon"
        :to="path"
      ></v-list-item>

    </v-list-group>

    <v-list-group value="Settings">
      <template v-slot:activator="{ props }">
        <v-list-item
          v-if="this.hasPermission('menu_setting')"
          v-bind="props"
          prepend-icon="mdi-cog-outline"
          title="Paramètrage"
        ></v-list-item>
      </template>

       <v-list-item
        v-if="this.hasPermission('view_typology')"
        prepend-icon="mdi-chevron-right"
        title="Typologie"
        to="/typologies_trees"
      ></v-list-item>

      <v-list-item
        v-if="this.hasPermission('view_entity')"
        prepend-icon="mdi-chevron-right"
        title="Entité"
        to="/entities_trees"
      ></v-list-item>

      <v-list-item
        v-if="this.hasPermission('view_contact')"
        prepend-icon="mdi-chevron-right"
        title="Contact"
        to="/contacts"
      ></v-list-item>

      <v-list-item
        v-if="this.hasPermission('view_action')"
        prepend-icon="mdi-chevron-right"
        title="Action"
        to="/actions"
      ></v-list-item>

       <v-list-item
        v-if="this.hasPermission('view_bannette')"
        prepend-icon="mdi-chevron-right"
        title="Bannettes"
        to="/bannettes"
      ></v-list-item>

      <v-list-item
        v-if="this.hasPermission('view_job')"
        prepend-icon="mdi-chevron-right"
        title="Postes"
        to="/jobs"
      ></v-list-item>

      <v-list-item
        v-if="this.hasPermission('view_memo')"
        prepend-icon="mdi-chevron-right"
        title="Modèle de lettre"
        to="/memo_models"
      ></v-list-item>

      <v-list-item
        v-for="([title, icon, path], i) in settings"
        :key="i"
        :title="title"
        :prepend-icon="icon"
        :value="title"
        :to="path"
      ></v-list-item>
    </v-list-group>

    <v-list-group value="Report">
      <template v-slot:activator="{ props }">
        <v-list-item
         v-if="this.hasPermission('view_memo')"
          v-bind="props"
          prepend-icon="mdi-folder-account"
          title="Rapport"
        >
        </v-list-item>
      </template>

      <v-list-item
        v-for="([title, icon, path], i) in report"
        :key="i"
        :value="title"
        :title="title"
        :prepend-icon="icon"
        :to="path"
      ></v-list-item>
    </v-list-group>

    <!-- <v-list-item
      prepend-icon="mdi-card-account-mail"
      title="Aide"
      to="/help"
    ></v-list-item> -->
  </v-list>
</template>

<script>
import permissions from "@/helpers/mixin-permissions";

export default {
  mixins: [permissions],

  data: () => ({
    open: ["Settings", "Gec", "Ged"],

    settings: [
      // ['Typologie', 'mdi-chevron-right', '/typologies_trees'],
      // ['Entité', 'mdi-chevron-right', '/entities_trees'],
      // ['Contact', 'mdi-chevron-right', '/contacts'], 
      // ['Action', 'mdi-chevron-right', '/actions'],
      // ["Bannettes", "mdi-chevron-right", "/bannettes"],
      // ['Poste', 'mdi-chevron-right', '/jobs'],
      // ['Modèle de lettre', 'mdi-chevron-right', '/memo_models'],
    ],

    gec: [
      // ["Nouveau Courrier", "mdi-chevron-right", "/mails/create"],
      // ["Mes Courriers", "mdi-chevron-right", "/mails"],
      // ["Mes Courriers Top Secret", "mdi-chevron-right", "/mails_topSecret"],
    ],

    ged: [
      // ["Indexation", "mdi-chevron-right", "/indexations"],
      // ['Consultation', "mdi-chevron-right", "/consultations"],
    ],
    report: [
      ["RapportGec", "mdi-chevron-right", "/report_gec"],
      ['RapportGed', "mdi-chevron-right", "/report_ged"],
    ],

  }),
};
</script>

<style scoped lang="scss">
.parent ::v-deep(.v-list-item) { 
  padding: 0px;
}
</style>
